export const handleDeemedFlowValidation = (
  forecast: number,
  nominatedQuantity: number,
  currentTime: number
) => {
  const totalFlowTime = 24; // Total flow time in hours. Fixed value
  const startTime = 5; // Fixed Value

  // Calculate flow rate per hour
  const flowRatePerHour = nominatedQuantity / totalFlowTime;

  // Calculate hours passed since start time
  const hoursPassed =
    currentTime >= startTime
      ? currentTime - startTime
      : totalFlowTime - startTime + currentTime;

  // Calculate quantity that has already flowed
  const quantityFlown = Math.round(flowRatePerHour * hoursPassed);
  return `Cannot nominate ${forecast.toLocaleString(
    'en-US'
  )} KWh. ${quantityFlown.toLocaleString(
    'en-US'
  )} KWh will have already flowed by this start time.`;
};

export const isValidNominationStartTime = (
  inputHour: number,
  validFrom: number
): boolean => {
  const validTo = 5;
  const NUMBER_23 = 23;
  if (validFrom >= validTo) {
    return (
      (inputHour >= validFrom && inputHour <= NUMBER_23) ||
      (inputHour >= 0 && inputHour < validTo)
    );
  }
  return inputHour >= validFrom && inputHour < validTo;
};

export const replaceStartTime = (num: number): number => {
  const NUMBER_25 = 25;
  switch (num) {
    case 24:
      return 0;
    case NUMBER_25:
      return 1;
    default:
      return num;
  }
};
